import Text from 'components/3catinfo/Text';
import clsx from 'clsx';
import styles from '../cosNoticia.module.scss';

const Embed = (props) => {
    const { text, tipus } = props;

    const stylesEmbed = clsx({
        [styles.embed]: true,
        [styles[tipus]]: !!tipus
    });

    return <Text text={text} className={stylesEmbed} dataTestId={`cos-noticia-embed-${tipus}`} />;
};

export default Embed;
